import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Col,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  //ModalHeader,
  ModalFooter,
} from "reactstrap";
//import axios from "axios";

import { useTranslation, withTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch } from "react-redux";

import { userEntitiesSave, userProfileSuccess } from "../../../redux/actions/actions";

import DateFormatPicker from "../Picker/DateFormatPicker";
import CurrencyPicker from "../Picker/CurrencyPicker";
import CulturePicker from "../Picker/CulturePicker";

import "react-toastify/dist/ReactToastify.css";
import { axiosPut } from "../../../helper/fetch";

const SettingsModal = ({shown, toggleClose, userinfo, title, name}) => {
  /** STATE */
  const [user, setUser] = useState({
    user: 0,
    dateFormat: 0,
    culture: 0,
    principalCurrency: 0,
    secondaryCurrency: 0,
  });
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorComponent, setErrorComponent] = useState("");
  const [rerender, setRerender]  = useState(true);

  /** HOOKS */
  const {t} = useTranslation();
  const dispatch = useDispatch();

  /*constructor(props) {
    super(props);

    this.state = {
      user: {
        user: 0,
        dateFormat: 0,
        culture: 0,
        principalCurrency: 0,
        secondaryCurrency: 0,
      },
      error: false,
      errorMessage: "",
      errorComponent: "",
    };
  }*/

  useEffect(() => {
    console.log('userinfo: ', userinfo);
  }, [userinfo]);

  const errorFn = () => {
    //const { t } = this.props;
    //const { user } = this.state;
    let error_ = false;
    let errorMessage_ = "";
    let errorComponent_ = "";
    if (!user.dateFormat || user.dateFormat === 0) {
      errorMessage_ = t("UserEdit.validationDateFormat");
      errorComponent_ = "dateFormat";
      error_ = true;
    } else if (!user.culture || user.culture === 0) {
      errorMessage_ = t("UserEdit.validationCulture");
      errorComponent_ = "culture";
      error_ = true;
    } else if (!user.principalCurrency || user.principalCurrency === 0) {
      errorMessage_ = t("UserEdit.validationPrincipalCurrency");
      errorComponent_ = "principalCurrency";
      error_ = true;
    } else if (!user.secondaryCurrency || user.secondaryCurrency === 0) {
      errorMessage_ = t("UserEdit.validationSecondaryCurrency");
      errorComponent_ = "secondaryCurrency";
      error_ = true;
    }
    setError(error_);
    setErrorMessage(errorMessage_);
    setErrorComponent(errorComponent_);
    /*this.setState({
      errorMessage,
      error,
      errorComponent,
    });*/
    return error_;
  };

  const handleDateFormatPicker = (event) => {
    //const { user, error, errorComponent } = this.state;
    const user_ = user;
    user_.dateFormat = event.target.value;
    if (error && errorComponent === "dateFormat") {
      setError(false);
      setErrorComponent("");
      /*const error = false;
      const errorComponent = "";
      this.setState({
        error,
        errorComponent,
      });*/
    }
    setUser(user);
    /*this.setState({
      user,
    });*/
  };

  const handlePrincipalCurrency = (event) => {
    //const { user, error, errorComponent } = this.state;
    const user_ = user;
    user_.principalCurrency = event.target.value;
    if (error && errorComponent === "principalCurrency") {
      setError(false);
      setErrorComponent("");
      /*const error = false;
      const errorComponent = "";
      this.setState({
        error,
        errorComponent,
      });*/
    }
    setUser(user_);
    /*this.setState({
      user,
    });*/
  };

  const handleSecondaryCurrency = (event) => {
    //const { user, error, errorComponent } = this.state;
    const user_ = user;
    user_.secondaryCurrency = event.target.value;
    if (error && errorComponent === "secondaryCurrency") {
      setError(false);
      setErrorComponent("");
      /*const error = false;
      const errorComponent = "";
      this.setState({
        error,
        errorComponent,
      });*/
    }
    setUser(user_);
    /*this.setState({
      user,
    });*/
  };

  const handleCulturePicker = (event) => {
    //const { user, error, errorComponent } = this.state;
    const user_ = user;
    user_.culture = parseInt(event.target.value);
    console.log(parseInt(event.target.value));
    console.log(user_);
    if (error && errorComponent === "culture") {
      setError(false);
      setErrorComponent("");
      /*const error = false;
      const errorComponent = "";
      this.setState({
        error,
        errorComponent,
      });*/
    }
    setUser(user_);
    setRerender(!rerender);
    /*this.setState({
      user,
    });*/
  };

  useEffect(() => {
    console.log(user);
  }, [user])

  const apply = async () => {
    //const { t } = this.props;
    //const { userinfo } = this.props; //PROPS
    const data = user;
    console.log('data: ', data);
    console.log('UserInfo: ', userinfo);
    userinfo.dateFormat = data.dateFormat;
    userinfo.culture = data.culture;
    userinfo.principalCurrency = data.principalCurrency;
    userinfo.secondaryCurrency = data.secondaryCurrency;
    
    if (!errorFn()) {
      try {
        await axiosPut(`api/user/update-settings/${data.user}`, data);
        /*await axios({
          url: `api/user/update-settings/${data.user}`,
          method: "PUT",
          data: JSON.stringify(data),
        });*/
        toast.success(t("SettingsModal.confirm"), {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        dispatch(userProfileSuccess(userinfo)); //PROPS
        toggleClose({ target: { name } }); //PROPS
      } catch (err) {
        console.error("Error al modificar la configuración del usuario ", err);
        toast.error(t("SettingsModal.saveError"), {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    }
  };

  const setValues = () => {
    //const { userinfo } = this.props; //PROPS
    const user_ = {
      user: userinfo.userId,
      dateFormat: userinfo.dateFormat,
      culture: userinfo.culture,
      principalCurrency: userinfo.principalCurrency,
      secondaryCurrency: userinfo.secondaryCurrency,
    };
    setUser(user_);
    //this.setState({ user });
  };

  //const { t, shown, toggleClose, title } = this.props;
  const containerStyle = { zIndex: 1500 };
  return (
    <Form>
      <Modal
        onOpened={setValues}
        isOpen={shown}
        className="c-modal-cover"
        toggle={toggleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        name={name}
      >
        {/*<ModalHeader toggle={true/*toggleDanger PROPS}>{title}</ModalHeader>*/}
        <ModalBody>
          <FormGroup row>
            <Col md="4">
              <Label style={{ paddingTop: 5 }}>
                {t("UserEdit.dateFormat")}
              </Label>
            </Col>
            <Col md="8">
              <DateFormatPicker
                id={user.dateFormat}
                onChange={handleDateFormatPicker}
                className='custom-select'
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md="4">
              <Label style={{ paddingTop: 5 }}>{t("UserEdit.culture")}</Label>
            </Col>
            <Col md="8">
              <CulturePicker
                id={user.culture}
                onChange={handleCulturePicker}
                className='custom-select'
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md="4">
              <Label htmlFor="text-input">
                {t("UserEdit.principalCurrency")}
              </Label>
            </Col>
            <Col md="8">
              <CurrencyPicker
                id={user.principalCurrency}
                onChange={handlePrincipalCurrency}
                className='custom-select'
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md="4">
              <Label htmlFor="text-input">
                {t("UserEdit.secondaryCurrency")}
              </Label>
            </Col>
            <Col md="8">
              <CurrencyPicker
                id={user.secondaryCurrency}
                onChange={handleSecondaryCurrency}
                className='custom-select'
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md="12" style={{ marginTop: 15 }}>
              <Alert color="danger" hidden={!error}>
                {errorMessage}
              </Alert>
            </Col>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={apply}>
            {t("SettingsModal.accept")}
          </Button>
          <Button color="primary" onClick={toggleClose} name={name}>
            {t("ChangePassword.close")}
          </Button>
        </ModalFooter>
        <div className="animated">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            style={containerStyle}
            closeOnClick
          />
        </div>
      </Modal>
    </Form>
  );
}
//shown, toggleClose, userinfo, title, name
SettingsModal.propTypes = {
  shown: PropTypes.bool,
  toggleClose: PropTypes.func,
  //userinfo: PropTypes.object,
  title: PropTypes.string,
  name: PropTypes.string,
  //toggleDanger: PropTypes.func,
};

//const mapStateToProps = ({ user: { userinfo } }) => userinfo;

export default withTranslation()(SettingsModal);
